document.addEventListener('DOMContentLoaded', () => {
  // 🔍 Observar cuando la vitrina se cargue dinámicamente
  const vitrinaContainer = document.querySelector('.related-products, .hdt-products, .product-recommendations');
  if (vitrinaContainer) {
    const observer = new MutationObserver(() => {
      inicializarColoresYTallas();
    });
    observer.observe(vitrinaContainer, { childList: true, subtree: true });
  }
});

function inicializarColoresYTallas() {
  const cards = document.querySelectorAll('.related-products .hdt-card-product, .hdt-products .hdt-card-product');

  cards.forEach(card => {
    const colorInputs = card.querySelectorAll('.hdt-color-list-item input[type="radio"]');
    const sizeButtons = card.querySelectorAll('.hdt-size-list-item');

    if (!colorInputs.length || !sizeButtons.length) return;

    // 💥 Mostrar tallas del color preseleccionado
    const checkedColor = card.querySelector('.hdt-color-list-item input[type="radio"]:checked');
    if (checkedColor) {
      mostrarTallas(card, checkedColor.value);
    }

    // 🎨 Escuchar cambios de color dentro de cada card
    colorInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        mostrarTallas(card, e.target.value);
      });
    });
  });
}

function mostrarTallas(card, colorValue) {
  const selectedColor = colorValue.toLowerCase().trim().replace(/\s+/g, "-");
  const sizeButtons = card.querySelectorAll('.hdt-size-list-item');
  sizeButtons.forEach(btn => btn.classList.add('hidden'));

  const visibles = card.querySelectorAll(`.hdt-size-list-item[data-color="${selectedColor}"]`);
  visibles.forEach(btn => btn.classList.remove('hidden'));
}